<template src="./VerSeguimientoPaciente.html"></template>

<script>
import moment from "moment";
import {
  consultarTextoResumen,
  agregarNotaEncuentro
} from "../../../apiService/request/CrudEncuentro";
import {
  consultarMarcaciones,
  consultarListaCuestionario,
  crearCuestionario,
  consultarEstructuraCuestionarioPorId
} from "../../../apiService/request/CrudSeguimiento";
import { actualizarEstadoOrdenes } from "../../../apiService/request/CrudOrdenes";
import Marcaciones from "../../Marcaciones/Marcaciones";
import VerCuestionarioSeguimiento from "../VerCuestionarioSeguimiento/VerCuestionarioSeguimiento";
import { reemplazarCaracteresEspeciales } from "../../../js/metodos_comunes";
import { serverBus } from "../../../main";
import SubirArchivo from "../../SubirArchivo/SubirArchivo";
export default {
  data() {
    return {
      texto_introductorio: null,
      formularioSeguimiento: {},
      idFormularioSeguimiento: "",
      banderaEncuesta: false,
      preguntasEncuestas: [],
      listaCuestionarios: [],
      informacionMarcaciones: [],
      keyFormulario: "",
      paciente: {},
      nuevaNota: "",
      notas: ""
    };
  },
  filters: {
    moment: function(date, format) {
      var fecha = isNaN(date) ? date : Number(date);
      return moment(fecha).format(format);
    }
  },
  props: {
    deshabilitado: {
      type: Boolean,
      default: false
    },
    mostrarBoton: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.consultarMarcacionesPacientes();
    this.consultarListaCuestionarioGeneral();
    this.$store.dispatch("setVariablesFormulariosOverlay", []);
    this.textoResumen();
  },
  mounted() {
    this.paciente = {
      documento: this.$store.getters.getCedulaPaciente,
      nombre: this.$store.getters.getNombrePaciente
    };
    serverBus.$on("consultarCuestionarioExistenteOverlay", (id_formulario, tipo, nombre) => {
      this.preguntasEncuestas = [];
      this.formularioSeguimiento = [];
      this.consultarEsquemaCuestionarioSeguimiento(id_formulario, tipo, nombre);
    });
  },
  beforeDestroy() {
    serverBus.$off("consultarCuestionarioExistenteOverlay");
    this.$store.dispatch("setIdFormularioOverlay", null);
    this.$store.dispatch("setVariablesFormulariosOverlay", []);
    this.$store.dispatch("setVariablesActualizadasOverlay", []);
    this.$store.dispatch("setNombreFormularioOverlay", null);
    this.$store.dispatch("setCampoIngresadoOverlay", null);
    this.$store.dispatch("setNombreCampoOverlay", null);
  },
  methods: {
    /**
     * Método que pasa la orden al estado "factura"
     */
    async facturarOrden(idOrden) {
      this.$store.dispatch("setCargando", true);
      try {
        await actualizarEstadoOrdenes(
          "factura",
          this.$store.state.provider_email,
          idOrden
        );
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setCargando", false);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async enviarSeguimiento() {
      this.$store.dispatch("setMensajeChatBox", "terminar");
    },
    // async consultarEsquemaFormularioSeguimiento(formulario_id) {
    //   try {
    //     const respuesta = await consultarEstructuraCuestionarioPorId(
    //       formulario_id,
    //       "formularios"
    //     );
    //     this.formularioSeguimiento = respuesta.data.data;
    //     this.$store.dispatch("setBanderaFormularioCreadoPanelOverlay", true);
    //     this.$store.dispatch(
    //       "setVariablesFormulariosOverlay",
    //       respuesta.data.data.variables
    //     );
    //     this.$store.dispatch("setNombreFormularioOverlay", respuesta.data.data.key);
    //     this.$store.dispatch("setColeccionOverlay", respuesta.data.data.coleccion);
    //   } catch (err) {}
    // },

    async consultarEsquemaCuestionarioSeguimiento(formulario_id,tipo, nombre) {
      try {
        this.$store.dispatch("setConsultarFormulario", '');
        const respuesta = await consultarEstructuraCuestionarioPorId(
          formulario_id,
          tipo,
          nombre
        );
        if (respuesta.status && respuesta.status == 200) {
          if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.texto_introductorio) {
            this.texto_introductorio = respuesta.data.data.texto_introductorio;
          } else {
            this.texto_introductorio = null;
          }
          this.preguntasEncuestas = respuesta.data.data.variables;
          this.keyFormulario = respuesta.data.data.key;
          this.$store.dispatch("setBanderaFormularioCreadoPanelOverlay", true);
          this.$store.dispatch("setVariablesFormulariosOverlay",respuesta.data.data.variables);
          this.$store.dispatch("setNombreFormularioOverlay", respuesta.data.data.key);
          this.$store.dispatch("setColeccionOverlay", respuesta.data.data.coleccion);
          // this.consultarListaCuestionarioGeneral()
          // this.preguntasEncuestas=respuesta
         
        }
      } catch (err) {}
    },
    async textoResumen() {
      try {
        const respuesta = await consultarTextoResumen(
          this.$store.getters.getIdVerEncuentrosOSeguimiento,
          "seguimientos"
        );
        this.notas = respuesta.data.data;
      } catch (err) {} finally {
      this.$store.dispatch("setCargando", false);
      }
    },
    async consultarMarcacionesPacientes() {
      try {
        const respuesta = await consultarMarcaciones(
          parseInt(this.$store.getters.getCedulaPaciente)
        );
        this.informacionMarcaciones = respuesta.data.data;
      } catch (err) {}
    },
    async consultarListaCuestionarioGeneral() {
      try {
        const respuesta = await consultarListaCuestionario(
          this.$store.getters.getNombreEventoOverlay,
          this.$store.getters.getIdVerEncuentrosOSeguimiento
        );
        this.listaCuestionarios = respuesta.data.data.dataCuestionarios;
        this.$emit("datosCargados");
      } catch (err) {}
    },
    async agregarNuevaNota() {
      this.$store.dispatch("setCargando", true);
      try {
        const respuesta = await agregarNotaEncuentro(
          this.$store.getters.getIdVerEncuentrosOSeguimiento,
          this.nuevaNota,
          this.$store.state.provider_email,
          "seguimientos"
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        this.nuevaNota = "";
        await this.textoResumen();
      }
    }
  },
  components: {
    Marcaciones,
    VerCuestionarioSeguimiento,
    SubirArchivo
  }
};
</script>

<style lang="scss" src="./VerSeguimientoPaciente.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/Seguimiento/VerSeguimientoPaciente/VerSeguimientoPaciente.vue